import { OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, tap, switchMap } from 'rxjs/operators';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { EventsService } from '../../../../services/events.service';
import { ModalActionsService } from '../../../../services/modalActions.service';
var AddEditEnquiryComponent = /** @class */ (function () {
    function AddEditEnquiryComponent(activeModal, notification, eventsService, modalActionsService) {
        var _this = this;
        this.activeModal = activeModal;
        this.notification = notification;
        this.eventsService = eventsService;
        this.modalActionsService = modalActionsService;
        this.prepareModal = function () {
            console.log('start', _this.enquiry);
            if (_this.enquiry.race && _this.enquiry.race.dateTime) {
                _this.meta.raceDateTime = _this.enquiry.race.dateTime;
            }
            var raceTime = _this.meta.raceDateTime
                ? " for the " + moment(_this.meta.raceDateTime).format('h:mm a') + " race"
                : '';
            _this.meta.title = " on '" + _this.enquiry.offender.knownAs + "'" + raceTime;
            _this.possibleOffences = [];
            _this.formOutcomes = {};
            _this.meta.jockeyHasDeferredDatesInterferenceBanner = false;
            _this.meta.jockeyHasDeferredDatesWhipBanner = false;
            _this.meta.enquiryMeta = {
                itemNote: _this.enquiry.itemNote,
                tottedUpDays: _this.enquiry.tottedUpDays,
                tottedUpOccurrence: _this.enquiry.tottedUpOccurrence,
                tottingUpPeriod: _this.enquiry.tottingUpPeriod,
                tottedUpDeferredSuspension: _this.enquiry.tottedUpDeferredSuspension
            };
            var enquiryIds = {
                year: _this.enquiry.race && _this.enquiry.race.year ? _this.enquiry.race.year : null,
                raceId: _this.enquiry.race && _this.enquiry.race.raceId ? _this.enquiry.race.raceId : null,
                divisionSequence: _this.enquiry.race && _this.enquiry.race.divisionSequence !== undefined ? _this.enquiry.race.divisionSequence : null,
                horseId: _this.enquiry.horse && _this.enquiry.horse.horseId ? _this.enquiry.horse.horseId : null
            };
            if (!_this.enquiry.enquiryId) {
                console.log('NEW');
                _this.enquiry.published = 0;
                _this.enquiry.category = 2;
                _this.enquiry.stage = 'racecourse';
                _this.enquiry.offence = null;
                _this.enquiry.outcomes = null;
                _this.enquiry.jockeyHasDeferredDatesWhip = false;
                _this.enquiry.jockeyHasDeferredDatesInterference = false;
                _this.enquiry.meta = _this.enquiry.meta ? _this.enquiry.meta : null;
            }
            else {
                console.log('EDIT');
                _this.getCameraAngles();
                if (_this.enquiry.outcomes && _this.enquiry.outcomes.length) {
                    _this.enquiry.outcomes.forEach(function (outcome) {
                        _this.formatFormOutcome(outcome);
                        // console.log('Received Outcomes:', outcome.objectType, outcome.value);
                        if (_this.typeHasSuspensionDates(outcome.objectType)) {
                            if (outcome.suspensionDates.length) {
                                _this.formOutcomes[outcome.objectType].suspensionDates = outcome.suspensionDates
                                    .map(function (el) { return ({ date: moment(el.date).format('YYYY-MM-DD') }); });
                            }
                            else {
                                _this.formOutcomes[outcome.objectType].suspensionDates = [];
                                for (var i = 0; i < _this.formOutcomes[outcome.objectType].value; i++) {
                                    _this.formOutcomes[outcome.objectType].suspensionDates.push({ date: '' });
                                }
                            }
                        }
                    });
                }
                _this.enquiry = {
                    enquiryId: _this.enquiry.enquiryId,
                    category: _this.enquiry.category,
                    stage: _this.enquiry.stage,
                    appealConclusion: _this.enquiry.appealConclusion,
                    deposit: _this.enquiry.deposit,
                    published: _this.enquiry.published,
                    offender: _this.enquiry.offender,
                    offence: {
                        offenceId: _this.enquiry.offence.id,
                        offenceDescription: _this.enquiry.offence.offence
                    },
                    cameraAngles: _this.enquiry.cameraAngles.map(function (c) { return c.id; }),
                    cameraStartTime: _this.enquiry.cameraStartTime,
                    cameraStopTime: _this.enquiry.cameraStopTime,
                    ptcComment: _this.enquiry.ptcComment ? _this.enquiry.ptcComment.comment : null,
                    notice: _this.enquiry.notice,
                    rir: _this.enquiry.rir,
                    rirComment: _this.enquiry.rirComment,
                    jockeyHasDeferredDatesWhip: !!_this.enquiry.jockeyHasDeferredDatesWhip,
                    jockeyHasDeferredDatesInterference: !!_this.enquiry.jockeyHasDeferredDatesInterference,
                    meta: _this.enquiry.meta ? _this.enquiry.meta : enquiryIds
                };
                _this.meta.jockeyHasDeferredDatesWhipOwnedByThisEnquiry = !!_this.enquiry.jockeyHasDeferredDatesWhip;
                _this.meta.jockeyHasDeferredDatesInterferenceOwnedByThisEnquiry = !!_this.enquiry.jockeyHasDeferredDatesInterference;
                /* Some insight in the next IF:
                *  Object.values() return value of keys in array format
                *  Array.some() return true if at least one element verify the condition, for this reason we check for `not-null`
                *  Because we check for `not-null`, we need to invert the whole condition as well, thus the first `not`
                */
                // Check meta for generic enquiries - if all ids in meta are `null`, set meta to null
                if (!Object.values(_this.enquiry.meta).some(function (attr) { return (attr !== null); })) {
                    _this.enquiry.meta = null;
                }
                _this.checkJockeyHasDeferredDatesInterference();
                _this.checkJockeyHasDeferredDatesWhip();
                _this.meta.saveEnabled = _this.isSaveAllowed();
            }
            _this.enquiry.userId = _this.userId;
            console.log('END', _this.enquiry);
            if (_this.nextStage) {
                var nextStageIndex = _this.meta.possibleStages.findIndex(function (s) { return s === _this.enquiry.stage; });
                // console.log(`[ DEBUG ] Requested to move to the next stage from ` +
                //   `${this.enquiry.stage} to ${this.meta.possibleStages[nextStageIndex]}`);
                _this.enquiry.stage = _this.meta.possibleStages[nextStageIndex + 1];
            }
            // console.log('[ DEBUG ] Enquiry ready:', this.enquiry, 'Outcomes:', this.formOutcomes);
        };
        this.offenceFormat = function (x) {
            return x.offenceDescription + (x.subOffenceDescription ? ' - ' + x.subOffenceDescription : '');
        };
        this.searchOffences = function (query$) { return query$.pipe(debounceTime(500), distinctUntilChanged(), map(function (q) {
            if (q.length < 3) {
                return;
            }
            else {
                _this.meta.possibleOffences.loading = true;
                return q;
            }
        }), 
        // tap(() => this.meta.possibleOffences.loading = true),
        switchMap(function (q) { return _this.modalActionsService.getEnquiryOffences(q, _this.enquiry.offender.type, _this.enquiry.category)
            .pipe(
        // map(res => res.data.slice(0, 6)),
        map(function (res) { return res.data; }), tap(function () { return _this.meta.possibleOffences.loadingFailed = false; }), catchError(function (err) {
            _this.meta.possibleOffences.loadingFailed = true;
            return of([]);
        })); }), tap(function () { return _this.meta.possibleOffences.loading = false; })); };
        this.getOutcomes = function (selection) {
            var offence = selection.item;
            _this.meta.enquiryMeta = null;
            _this.formOutcomes = {};
            _this.enquiry.jockeyHasDeferredDatesWhip = false;
            _this.enquiry.jockeyHasDeferredDatesInterference = false;
            _this.meta.jockeyHasDeferredDatesInterferenceBanner = false;
            _this.meta.jockeyHasDeferredDatesWhipBanner = false;
            if (offence !== undefined) {
                _this.checkJockeyHasDeferredDatesInterference(offence);
                _this.checkJockeyHasDeferredDatesWhip(offence);
                _this.getCameraAngles();
                _this.meta.possibleOutcomes.loading = true;
                _this.modalActionsService.getEnquiryOutcomes(offence, _this.enquiry.offender).subscribe(function (res) {
                    res.outcomes.forEach(function (outcome) {
                        _this.formatFormOutcome(outcome);
                    });
                    _this.meta.enquiryMeta = {
                        itemNote: res.itemNote,
                        tottedUpDays: res.tottedUpDays,
                        tottedUpOccurrence: res.tottedUpOccurrence,
                        tottingUpPeriod: res.tottingUpPeriod,
                        tottedUpDeferredSuspension: res.tottedUpDeferredSuspension
                    };
                    // console.log('Offence:', offence, 'Outcomes:', this.formOutcomes);
                    _this.meta.saveEnabled = _this.isSaveAllowed();
                    _this.meta.possibleOutcomes.loading = false;
                }, function (err) {
                    _this.notification.error("Could't load the possible outcomes: " +
                        ("" + _this.eventsService.getApiErrorMessage(err)), 'Error!', { disableTimeOut: true });
                    _this.meta.possibleOutcomes.loading = false;
                }, function () {
                    _this.meta.saveEnabled = _this.isSaveAllowed();
                });
            }
        };
        this.checkJockeyHasDeferredDatesInterference = function (offence) {
            if (offence === void 0) { offence = null; }
            _this.meta.jockeyHasDeferredDatesInterferenceBanner = false;
            var selectedOffence = offence || (_this.enquiry && _this.enquiry.offence);
            var offenceId = selectedOffence && (selectedOffence.offenceId || selectedOffence.id);
            if ((offenceId === 109 || offenceId === 110 || offenceId === 111) &&
                _this.enquiry.offender &&
                _this.enquiry.offender.type === 'jockey' &&
                _this.enquiry.offender.id) {
                _this.modalActionsService.getJockeyHasDeferredDatesInterference(_this.enquiry.offender.id).subscribe(function (res) {
                    // Banner only when another enquiry owns deferred dates for this jockey
                    _this.meta.jockeyHasDeferredDatesInterferenceBanner =
                        Number(res.jockeyHasDeferredDatesInterference) === 1 &&
                            !_this.meta.jockeyHasDeferredDatesInterferenceOwnedByThisEnquiry;
                }, function (err) {
                    _this.meta.jockeyHasDeferredDatesInterferenceBanner = false;
                    console.log('Could not check deferred dates interference', err);
                });
            }
        };
        this.checkJockeyHasDeferredDatesWhip = function (offence) {
            if (offence === void 0) { offence = null; }
            _this.meta.jockeyHasDeferredDatesWhipBanner = false;
            var selectedOffence = offence || (_this.enquiry && _this.enquiry.offence);
            var offenceId = selectedOffence && (selectedOffence.offenceId || selectedOffence.id);
            var year = (_this.enquiry.meta && _this.enquiry.meta.year) ||
                (_this.enquiry.race && _this.enquiry.race.year);
            var raceId = (_this.enquiry.meta && _this.enquiry.meta.raceId) ||
                (_this.enquiry.race && _this.enquiry.race.raceId);
            var divisionSequence = _this.enquiry.meta && _this.enquiry.meta.divisionSequence !== undefined && _this.enquiry.meta.divisionSequence !== null
                ? _this.enquiry.meta.divisionSequence
                : (_this.enquiry.race && _this.enquiry.race.divisionSequence);
            if (offenceId === 648 &&
                _this.enquiry.offender &&
                _this.enquiry.offender.type === 'jockey' &&
                _this.enquiry.offender.id &&
                year != null &&
                raceId != null &&
                divisionSequence != null) {
                _this.modalActionsService.getJockeyHasDeferredDatesWhip(_this.enquiry.offender.id, year, raceId, divisionSequence).subscribe(function (res) {
                    // Banner only when another enquiry owns deferred dates for this jockey
                    _this.meta.jockeyHasDeferredDatesWhipBanner =
                        Number(res.jockeyHasDeferredDatesWhip) === 1 &&
                            !_this.meta.jockeyHasDeferredDatesWhipOwnedByThisEnquiry;
                }, function (err) {
                    _this.meta.jockeyHasDeferredDatesWhipBanner = false;
                    console.log('Could not check deferred dates whip', err);
                });
            }
        };
        this.suspensionListener = function (outcomeType) {
            if (!_this.formOutcomes[outcomeType].isApplied || _this.formOutcomes[outcomeType].datesPending) {
                _this.formOutcomes[outcomeType].value = null;
                _this.formOutcomes[outcomeType].suspensionDates = [];
            }
            else {
                if (!_this.formOutcomes[outcomeType].value) {
                    _this.formOutcomes[outcomeType].value = _this.formOutcomes[outcomeType].suggestion.lower;
                    _this.getSuspensionDates(_this.formOutcomes[outcomeType].value, outcomeType, _this.formOutcomes[outcomeType].suggestion.period);
                }
            }
            // console.log('Suspension listener', this.formOutcomes[outcomeType]);
        };
        this.fineListener = function (toggle, outcomeType) {
            if (toggle === false) {
                _this.formOutcomes[outcomeType].value = null;
            }
            if (toggle === true) {
                if (!_this.formOutcomes[outcomeType].value) {
                    _this.formOutcomes[outcomeType].value = _this.formOutcomes[outcomeType].suggestion.lower;
                }
            }
        };
        this.typeHasSuspensionDates = function (outcomeType) {
            return outcomeType === 'suspension';
        };
        this.getSuspensionDates = function (input, outcomeType, period) {
            // console.log('Suspension Dates request:', this.formOutcomes[outcomeType].value, outcomeType, period);
            // Known Bug of Angular require this workaround: https://github.com/angular/angular/issues/12540
            // amount = amount && (typeof amount === 'object') ? Number(amount.data) : Number(amount);
            var amount = _this.formOutcomes[outcomeType].value;
            if (amount) {
                if (_this.suspensionDateRequest) {
                    _this.suspensionDateRequest.unsubscribe();
                }
                _this.meta.possibleSuspensionDates.loading = true;
                period = period.toLowerCase().replace('(s)', 's');
                _this.formOutcomes[outcomeType].suspensionDates = [];
                if (_this.enquiry.meta && _this.enquiry.meta.raceId) {
                    _this.suspensionDateRequest = _this.modalActionsService
                        .getEnquirySuspensionDates(_this.enquiry, amount, period).subscribe(function (res) {
                        _this.formOutcomes[outcomeType].suspensionDates = res.map(function (sd) { return ({ date: moment(sd.date).format('YYYY-MM-DD') }); });
                        _this.meta.possibleSuspensionDates.loading = false;
                        console.log('Dates: ', _this.formOutcomes[outcomeType].value, _this.formOutcomes[outcomeType].suspensionDates);
                    }, function (err) {
                        _this.notification.error("Could't load the possible suspension dates: " +
                            ("" + _this.eventsService.getApiErrorMessage(err)), 'Error!', { disableTimeOut: true });
                        for (var i = 0; i < amount; i++) {
                            _this.formOutcomes[outcomeType].suspensionDates.push({ date: '' });
                        }
                        _this.meta.possibleSuspensionDates.loading = false;
                    });
                }
                else {
                    if (period == 'months') {
                        _this.formOutcomes[outcomeType].suspensionDates.push({ date: '' });
                        _this.formOutcomes[outcomeType].suspensionDates.push({ date: '' });
                    }
                    else {
                        for (var i = 0; i < amount; i++) {
                            _this.formOutcomes[outcomeType].suspensionDates.push({ date: '' });
                        }
                    }
                    _this.meta.possibleSuspensionDates.loading = false;
                }
            }
            else {
                _this.formOutcomes[outcomeType].suspensionDates = [];
            }
        };
        this.save = function () {
            var payload = Object.assign({}, _this.enquiry, _this.meta.enquiryMeta);
            payload.date = payload.date ? moment(payload.date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
            payload.jockeyHasDeferredDatesWhip = _this.enquiry.stage === 'dp_committee'
                ? (_this.showJockeyHasDeferredDatesWhip && _this.enquiry.jockeyHasDeferredDatesWhip ? 1 : 0)
                : (_this.enquiry.jockeyHasDeferredDatesWhip ? 1 : 0);
            payload.jockeyHasDeferredDatesInterference = _this.enquiry.stage === 'dp_committee'
                ? (_this.showJockeyHasDeferredDatesInterference && _this.enquiry.jockeyHasDeferredDatesInterference ? 1 : 0)
                : (_this.enquiry.jockeyHasDeferredDatesInterference ? 1 : 0);
            var validSuspensionOutcome = false;
            payload.outcomes = [];
            Object.keys(_this.formOutcomes).forEach(function (key) {
                var processedOutcome = Object.assign({}, _this.formOutcomes[key]);
                // If this is a stage change, remove all outcomes' IDs
                processedOutcome.id = _this.nextStage ? null : processedOutcome.id;
                // Validate Dates for 'suspension' outcome
                validSuspensionOutcome = _this.suspensionDatesValidation(processedOutcome);
                // Special cases
                if (processedOutcome.type === 'inBreach') {
                    processedOutcome.isApplied = processedOutcome.value === 'in_breach' ? true : false;
                }
                if (processedOutcome.type === 'advisory') {
                    processedOutcome.value = processedOutcome.attributes.type;
                }
                if (processedOutcome.type === 'suspension') {
                    if (validSuspensionOutcome) {
                        if (processedOutcome.suspensionDates && processedOutcome.suspensionDates.length) {
                            if (processedOutcome.suspensionDates[0].date === '') {
                                processedOutcome.suspensionDates = [];
                            }
                            else {
                                processedOutcome.suspensionDates = processedOutcome.suspensionDates
                                    .map(function (item) { return ({ date: moment(item.date).format('YYYY-MM-DD') }); });
                            }
                        }
                        if (processedOutcome.datesPending === true) {
                            processedOutcome.suspensionDates = [];
                            processedOutcome.value = null;
                        }
                    }
                    else {
                        return;
                    }
                }
                // If refer is true, every other outcome is null
                if (_this.formOutcomes['refer'].isApplied === true) {
                    if (processedOutcome.type !== 'inBreach' && processedOutcome.type !== 'refer') {
                        processedOutcome.value = null;
                        processedOutcome.isApplied = null;
                        if (processedOutcome.suspensionDates) {
                            processedOutcome.suspensionDates = [];
                        }
                    }
                }
                // Fallback check to avoid sending non-boolean isApplied
                if (processedOutcome.value !== undefined) {
                    if (processedOutcome.isApplied === undefined) {
                        processedOutcome.isApplied = !!processedOutcome.value;
                    }
                }
                payload.outcomes.push(processedOutcome);
                // console.log('[ DEBUG ] Preparing Outcome before Save',
                //   processedOutcome.id,
                //   processedOutcome.type,
                //   'applied: ' + processedOutcome.isApplied,
                //   processedOutcome.value
                // );
            });
            // Clean up outcomes isApplied value if BreachStatus is false
            var breachStatus = payload.outcomes.find(function (eo) { return eo.type === 'inBreach'; });
            if (breachStatus !== undefined && breachStatus.isApplied === false) {
                payload.outcomes = payload.outcomes
                    .map(function (outcome) { return outcome.type === 'inBreach' ? outcome : Object.assign({}, outcome, { isApplied: false }); });
            }
            if (validSuspensionOutcome) {
                console.log('[ DEBUG ] Saving enquiry, payload to be sent:', payload);
                var request = _this.modalActionsService.createEnquiry(payload);
                if (payload.enquiryId) {
                    request = _this.modalActionsService.updateEnquiry(payload);
                }
                _this.meta.saving = true;
                request.subscribe(function (res) {
                    console.log('[ DEBUG ] Enquiry saved, response returned:', res);
                    _this.eventsService.changeEnquiriesData({ section: 'enquiries', result: res });
                    _this.notification.success("Enquiry saved.", 'Success!');
                    _this.activeModal.close(res);
                    _this.meta.saving = false;
                }, function (err) {
                    _this.notification.error("Could't save this enquiry: " +
                        ("" + _this.eventsService.getApiErrorMessage(err)), 'Error!', { disableTimeOut: true });
                    _this.meta.saving = false;
                });
            }
            else {
                console.log(validSuspensionOutcome);
                _this.meta.saving = false;
            }
        };
        this.cancel = function (action) {
            _this.activeModal.dismiss(action);
        };
    }
    AddEditEnquiryComponent.prototype.ngOnInit = function () {
        var _this = this;
        // console.log('Opening enquiry edit/create', this.enquiry);
        this.meta = {
            title: '',
            raceDateTime: this.enquiry && this.enquiry.race && this.enquiry.race.dateTime
                ? this.enquiry.race.dateTime
                : null,
            edit: !!(this.enquiry && this.enquiry.enquiryId),
            loading: false,
            saveEnabled: false,
            saving: false,
            possibleOffences: {
                loading: false,
                loadingFailed: false,
                saving: false
            },
            possibleCategories: [
                { value: 1, text: 'Disciplinary' },
                { value: 2, text: 'Racecourse' },
            ],
            appealOutcomes: [
                { value: 'upheld', text: 'Upheld' },
                { value: 'upheld_in_part', text: 'Upheld In Part' },
                { value: 'dismissed', text: 'Dismissed' },
            ],
            depositOutcomes: [
                { value: 'forfeited', text: 'Forfeited' },
                { value: 'returned', text: 'Returned' },
                { value: 'n/a', text: 'N/A' },
            ],
            possibleStages: [
                'racecourse',
                'dp_committee',
                'appeal',
                'legal'
            ],
            possibleOutcomes: {
                loading: false,
                saving: false
            },
            possibleSuspensionDates: {
                loading: false,
                saving: false
            },
            cameraAngles: {
                loading: false,
                saving: false
            },
            enquiryMeta: null,
            jockeyHasDeferredDatesInterferenceBanner: false,
            jockeyHasDeferredDatesWhipBanner: false,
            jockeyHasDeferredDatesWhipOwnedByThisEnquiry: false,
            jockeyHasDeferredDatesInterferenceOwnedByThisEnquiry: false
        };
        this.eventsService.observableUser.subscribe(function (data) {
            _this.userId = data.id;
            _this.userIsDisciplinary = data.roles.find(function (r) { return r === 'ROLE_HEAD_OFFICE'; }) !== undefined;
            _this.userIsSteward = data.roles.find(function (r) { return r === 'ROLE_STEWARD_ROOM_ASSISTANT' || r === 'ROLE_STIPE'; }) !== undefined;
        });
        this.prepareModal();
    };
    AddEditEnquiryComponent.prototype.applyJockeyMaster = function () {
        this.enquiry.offender.applyJockeyMaster = !this.enquiry.offender.applyJockeyMaster;
    };
    AddEditEnquiryComponent.prototype.formatFormOutcome = function (outcome) {
        if ((this.userIsSteward
            && (outcome.applicableByRole === 'ROLE_STEWARD_ROOM_ASSISTANT' || outcome.applicableByRole === 'ROLE_STIPE')) ||
            // (this.userIsDisciplinary && outcome.applicableByRole === 'ROLE_HEAD_OFFICE')
            (this.userIsDisciplinary)) {
            this.formOutcomes[outcome.objectType] = {
                id: outcome.id || null,
                value: outcome.value,
                label: outcome.objectType.replace(/([A-Z])/g, ' $1'),
                type: outcome.objectType,
                isApplied: outcome.isApplied,
                attributes: Object.assign({}, outcome.attributes),
            };
            this.formOutcomes[outcome.objectType].suggestion = this.formatSuggestions(outcome.attributes);
            if (outcome.objectType === 'suspension') {
                if (outcome.suspensionDates && outcome.suspensionDates.length) {
                    this.formOutcomes[outcome.objectType].datesPending = false;
                }
                else {
                    this.formOutcomes[outcome.objectType].datesPending = true;
                }
            }
        }
    };
    AddEditEnquiryComponent.prototype.formatSuggestions = function (attributes) {
        var suggestions = {};
        if (attributes && Object.keys(attributes).length) {
            if (attributes.period) {
                suggestions['period'] = attributes.period;
            }
            if (this.userIsSteward) {
                if (attributes.role_steward_room_assistant_lower) {
                    suggestions['lower'] = attributes.role_steward_room_assistant_lower;
                }
                if (attributes.role_steward_room_assistant_upper) {
                    suggestions['upper'] = attributes.role_steward_room_assistant_upper;
                }
            }
            if (this.userIsDisciplinary) {
                if (attributes.role_steward_room_assistant_lower) {
                    suggestions['lower'] = attributes.role_steward_room_assistant_lower;
                }
                if (attributes.role_head_office_lower) {
                    suggestions['lower'] = attributes.role_head_office_lower;
                }
                if (attributes.role_steward_room_assistant_upper) {
                    suggestions['upper'] = attributes.role_steward_room_assistant_upper;
                }
                if (attributes.role_head_office_upper) {
                    suggestions['upper'] = attributes.role_head_office_upper;
                }
            }
            return suggestions;
        }
    };
    AddEditEnquiryComponent.prototype.updateStage = function (category) {
        // console.log(`[ DEBUG ] Updating Stage`);
        if (!this.enquiry.id) {
            if (category === 1) {
                this.enquiry.stage = 'dp_committee';
            }
            else {
                this.enquiry.stage = 'racecourse';
            }
        }
    };
    AddEditEnquiryComponent.prototype.isSaveAllowed = function () {
        if (!this.formOutcomes) {
            return false;
        }
        if (!this.formOutcomes['inBreach'] || this.formOutcomes['inBreach'].value === null) {
            return false;
        }
        return true;
    };
    Object.defineProperty(AddEditEnquiryComponent.prototype, "showJockeyHasDeferredDatesWhip", {
        get: function () {
            var offenceId = this.enquiry && this.enquiry.offence &&
                (this.enquiry.offence.offenceId || this.enquiry.offence.id);
            return !!(this.enquiry.stage === 'dp_committee' &&
                (!this.meta.jockeyHasDeferredDatesWhipBanner || this.meta.jockeyHasDeferredDatesWhipOwnedByThisEnquiry) &&
                offenceId === 648 &&
                this.enquiry.offender && this.enquiry.offender.type === 'jockey' &&
                this.formOutcomes && this.formOutcomes['inBreach'] &&
                this.formOutcomes['inBreach'].value &&
                this.formOutcomes['inBreach'].value !== 'not_in_breach');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddEditEnquiryComponent.prototype, "showJockeyHasDeferredDatesInterference", {
        get: function () {
            var offenceId = this.enquiry && this.enquiry.offence &&
                (this.enquiry.offence.offenceId || this.enquiry.offence.id);
            return !!(this.enquiry.stage === 'dp_committee' &&
                (!this.meta.jockeyHasDeferredDatesInterferenceBanner || this.meta.jockeyHasDeferredDatesInterferenceOwnedByThisEnquiry) &&
                (offenceId === 109 || offenceId === 110 || offenceId === 111) &&
                this.enquiry.offender && this.enquiry.offender.type === 'jockey' &&
                this.formOutcomes && this.formOutcomes['inBreach'] &&
                this.formOutcomes['inBreach'].value &&
                this.formOutcomes['inBreach'].value !== 'not_in_breach');
        },
        enumerable: true,
        configurable: true
    });
    AddEditEnquiryComponent.prototype.getCameraAngles = function () {
        var _this = this;
        this.meta.cameraAngles.loading = true;
        this.modalActionsService.getCameraAngles().subscribe(function (res) {
            _this.possibleCameras = res.map(function (camera) {
                return ({ id: camera.id, name: camera.title + (camera.description ? ' - ' + camera.description : '') });
            });
            _this.meta.cameraAngles.loading = false;
        }, function (err) {
            _this.notification.error("Could't load the possible camera angles: " +
                ("" + _this.eventsService.getApiErrorMessage(err)), 'Error!', { disableTimeOut: true });
            _this.meta.cameraAngles.loading = false;
        });
    };
    AddEditEnquiryComponent.prototype.suspensionDatesValidation = function (suspensionOutcome) {
        var valid = true;
        if (suspensionOutcome.type === 'suspension') {
            if (suspensionOutcome.isApplied) {
                if (!suspensionOutcome.datesPending) {
                    if (suspensionOutcome.value) {
                        // Check if not all dates are provided
                        if (!suspensionOutcome.suspensionDates.every(function (sd) { return sd.date.length === 10; })) {
                            valid = false;
                        }
                        // If the previous check was true
                        if (valid === false) {
                            // Check if all dates are empty
                            if (suspensionOutcome.suspensionDates.every(function (sd) { return sd.date.length === 0; })) {
                                // ... alright, you can go then
                                valid = true;
                            }
                            else {
                                // ... you did fuck up, boy
                                this.notification.error("Either all suspension dates are provided or none at all.", 'Error!');
                            }
                        }
                    }
                    else {
                        this.notification.error("Suspension Outcome has been selected but not amount has been specified.", 'Error!');
                        valid = false;
                    }
                }
            }
        }
        return valid;
    };
    return AddEditEnquiryComponent;
}());
export { AddEditEnquiryComponent };
